// extracted by mini-css-extract-plugin
export default {"cls1":"JS36fa3FM84i8XK_0YJw","cls2":"Z3O69D3qBDtar_RBTQum JS36fa3FM84i8XK_0YJw"};